import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import {
  FaCalendarAlt,
  FaFileAlt,
  FaMoneyBillWave,
  FaPhone,
  FaShip,
  FaClock as FaTime,
  FaUser,
  FaFileDownload,
} from "react-icons/fa";
import * as _service from "../../service/payments.service";
import { dateConverter, timeConverter } from "../../helpers/functions";
import { handlePrint } from "./helper";

const Details = ({ isOpen, onToggle, id }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    if (isOpen && id) handleData();
  }, [isOpen, id]); // eslint-disable-line

  const handleData = async () => {
    try {
      const response = await _service.details(id);
      const { data, payments = [] } = response;
      setData({ ...data, payments });
    } catch (error) {
      console.error(error);
      onToggle();
    }
  };

  return (
    <Modal isOpen={isOpen} centered size="lg" toggle={onToggle}>
      <ModalHeader toggle={onToggle} className="border-bottom-0 pb-0">
        <span className="fw-bold text-dark fs-5">
          Payment Details - {data.boat || data.name || ""}
        </span>
      </ModalHeader>
      <ModalBody className="bg-light p-3 rounded-bottom">
        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <div className="card border-0 shadow-sm h-100 bg-white">
              <div className="card-body p-3">
                <div
                  className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom text-primary fw-bold small"
                  style={{ letterSpacing: "0.5px" }}
                >
                  <FaUser /> Customer Details
                </div>
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                      style={{ width: "36px", height: "36px", color: "#006aae", flexShrink: 0 }}
                    >
                      <FaUser />
                    </div>
                    <div>
                      <small className="text-muted d-block" style={{ fontSize: "11px" }}>
                        Customer Name
                      </small>
                      <span className="fw-semibold text-dark">{data.name || "-"}</span>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                      style={{ width: "36px", height: "36px", color: "#006aae", flexShrink: 0 }}
                    >
                      <FaPhone />
                    </div>
                    <div>
                      <small className="text-muted d-block" style={{ fontSize: "11px" }}>
                        Mobile Number
                      </small>
                      <span className="fw-semibold text-dark">{data.mobile || "-"}</span>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                      style={{ width: "36px", height: "36px", color: "#006aae", flexShrink: 0 }}
                    >
                      <FaShip />
                    </div>
                    <div>
                      <small className="text-muted d-block" style={{ fontSize: "11px" }}>
                        Boat Name
                      </small>
                      <span className="fw-semibold text-dark">{data.boat || "-"}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card border-0 shadow-sm h-100 bg-white">
              <div className="card-body p-3">
                <div
                  className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom text-primary fw-bold small"
                  style={{ letterSpacing: "0.5px" }}
                >
                  <FaMoneyBillWave /> Payment Details
                </div>

                <div className="row g-3 mb-3">
                  <div className="col-6">
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                        style={{ width: "32px", height: "32px", color: "#006aae", flexShrink: 0 }}
                      >
                        <FaCalendarAlt />
                      </div>
                      <div>
                        <small className="text-muted d-block" style={{ fontSize: "11px" }}>
                          Date
                        </small>
                        <span className="fw-semibold text-dark small">
                          {dateConverter(data.date)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                        style={{ width: "32px", height: "32px", color: "#006aae", flexShrink: 0 }}
                      >
                        <FaTime />
                      </div>
                      <div>
                        <small className="text-muted d-block" style={{ fontSize: "11px" }}>
                          Time
                        </small>
                        <span className="fw-semibold text-dark small">
                          {timeConverter(data.time)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-start gap-3 mb-3 p-2 bg-light rounded border border-light">
                  <div
                    className="rounded-circle bg-white d-flex align-items-center justify-content-center mt-1"
                    style={{ width: "32px", height: "32px", color: "#006aae", flexShrink: 0 }}
                  >
                    <FaFileAlt />
                  </div>
                  <div>
                    <small className="text-muted d-block" style={{ fontSize: "11px" }}>
                      Description / Remarks
                    </small>
                    <span className="text-dark small" style={{ wordBreak: "break-word" }}>
                      {data.remarks || "-"}
                    </span>
                  </div>
                </div>

                <div className="row g-2 pt-2 border-top">
                  <div className="col-6">
                    <div
                      className="p-2 rounded text-center border border-success border-opacity-10"
                      style={{ backgroundColor: "rgba(25, 135, 84, 0.08)", color: "#198754" }}
                    >
                      <small className="text-muted d-block" style={{ fontSize: "10px" }}>
                        Total Amount
                      </small>
                      <span className="fw-bold fs-6">{Number(data.amount || 0).toFixed(2)}</span>
                    </div>
                  </div>
                  <div className="col-6">
                    <div
                      className="p-2 rounded text-center border"
                      style={{
                        backgroundColor:
                          Number(data.dueAmount || 0) > 0
                            ? "rgba(220, 53, 69, 0.08)"
                            : "rgba(25, 135, 84, 0.08)",
                        color: Number(data.dueAmount || 0) > 0 ? "#dc3545" : "#198754",
                        borderColor:
                          Number(data.dueAmount || 0) > 0
                            ? "rgba(220, 53, 69, 0.1)"
                            : "rgba(25, 135, 84, 0.1)",
                      }}
                    >
                      <small className="text-muted d-block" style={{ fontSize: "10px" }}>
                        Due Amount
                      </small>
                      <span className="fw-bold fs-6">{Number(data.dueAmount || 0).toFixed(2)}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card border-0 shadow-sm mt-3 bg-white">
          <div className="card-body p-3">
            <h6
              className="fw-bold text-dark mb-3 small"
              style={{ letterSpacing: "0.5px" }}
            >
              Spare Parts & Services
            </h6>
            <div className="table-responsive rounded border">
              {data.parts?.length ? (
                <table className="table table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="text-center" style={{ width: "50px" }}>
                        #
                      </th>
                      <th>Part / Service</th>
                      <th className="text-end">Amount</th>
                      <th className="text-end" style={{ width: "80px" }}>
                        Qty
                      </th>
                      <th className="text-end">Total</th>
                    </tr>
                  </thead>
                  <tbody className="small">
                    {data.parts?.map((part, index) => {
                      if (!part.part) return null;
                      return (
                        <tr key={index}>
                          <td className="text-muted text-center">{index + 1}</td>
                          <td className="fw-medium text-dark">{part.part}</td>
                          <td className="text-end">{Number(part.amount || 0).toFixed(2)}</td>
                          <td className="text-end text-center">{part.quantity}</td>
                          <td className="text-end fw-semibold text-dark">
                            {Number(part.total || 0).toFixed(2)}
                          </td>
                        </tr>
                      );
                    })}

                    <tr className="table-light">
                      <td colSpan="4" className="text-end fw-semibold">
                        Subtotal
                      </td>
                      <td className="text-end fw-semibold text-dark">
                        {data.parts?.reduce((sum, p) => sum + Number(p.total || 0), 0).toFixed(2)}
                      </td>
                    </tr>

                    {data.labourCharge ? (
                      <tr>
                        <td colSpan="4" className="text-end fw-semibold">
                          Labour
                        </td>
                        <td className="text-end text-primary fw-semibold">
                          +{Number(data.labourCharge || 0).toFixed(2)}
                        </td>
                      </tr>
                    ) : null}

                    {data.discount ? (
                      <tr>
                        <td colSpan="4" className="text-end fw-semibold">
                          Discount
                        </td>
                        <td className="text-end text-danger fw-semibold">
                          -{Number(data.discount || 0).toFixed(2)}
                        </td>
                      </tr>
                    ) : null}

                    <tr className="border-top" style={{ borderTopWidth: "2px" }}>
                      <td colSpan="4" className="text-end fw-bold">
                        Grand Total
                      </td>
                      <td className="text-end text-success fw-bold fs-6">
                        {Number(data.amount || 0).toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <div className="p-3 text-center text-muted">
                  No spare parts or services included.
                </div>
              )}
            </div>
            {data.parts?.length > 0 && (
              <div className="d-flex justify-content-end mt-2">
                <small className="text-muted">{data.parts?.length || 0} parts included</small>
              </div>
            )}
          </div>
        </div>

        {data.payments?.length > 0 && (
          <div className="card border-0 shadow-sm mt-3 bg-white">
            <div className="card-body p-3">
              <h6
                className="fw-bold text-dark mb-3 small"
                style={{ letterSpacing: "0.5px" }}
              >
                Payment History
              </h6>
              <div className="table-responsive rounded border">
                <table className="table table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "50px" }} className="text-center">
                        #
                      </th>
                      <th>Date & Time</th>
                      <th className="text-end">Amount Paid</th>
                    </tr>
                  </thead>
                  <tbody className="small">
                    {data.payments.map((payment, idx) => (
                      <tr key={idx}>
                        <td className="text-muted text-center">{idx + 1}</td>
                        <td className="text-dark">
                          {dateConverter(payment.date)} at {timeConverter(payment.time)}
                        </td>
                        <td className="text-end fw-semibold text-success">
                          {Number(payment.amount).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        <div className="d-flex justify-content-end mt-4 gap-3">
          <button className="btn btn-reset" onClick={onToggle}>
            Close
          </button>
          <button className="btn btn-submit" onClick={() => handlePrint(data)}>
            <FaFileDownload className="me-2" /> Share
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Details;
